import { createContext, useContext } from 'react'
import { decodeToken } from '../helpers/decodeToken'
import { AccessTokenPayload } from '../types'

const AccessTokenContext = createContext<string | undefined>(undefined)

export const AccessTokenProvider = AccessTokenContext.Provider

export const useAccessToken = () => useContext(AccessTokenContext)

export const useDecodedAccessToken = () => {
  const token = useContext(AccessTokenContext)
  return token ? decodeToken<AccessTokenPayload>(token) : undefined
}
